import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { MenuItem, MenuItemIconType } from "../../types/system/MenuItem";
import MainMenuCollection from "./MainMenuCollection";
import { IAppState } from "../../state/Store";
import {
    addExpandedMenuItem,
    remExpandedMenuItem,
} from "../../state/system/UIConfiguration";

interface MenuItemProps {
    item: MenuItem;
    selected: MenuItem;
    collapsed: boolean;
    expanded: string[];

    menuItemClicked: (item: MenuItem) => void;
    addExpandedMenuItem: (id: string) => void;
    remExpandedMenuItem: (id: string) => void;
}

interface MenuItemState {
    myRef: React.RefObject<HTMLAnchorElement>;
    open: boolean;
    init: boolean;
}

class MainMenuItem extends React.Component<MenuItemProps, MenuItemState> {
    state = {
        myRef: React.createRef<HTMLAnchorElement>(),
        open: false,
        init: true,
    };

    static getDerivedStateFromProps(
        props: MenuItemProps,
        state: MenuItemState,
    ) {
        return {
            ...state,
            open: props.expanded.includes(props.item.id),
        };
    }

    clicked() {
        this.state.myRef.current.blur();

        this.props.menuItemClicked(this.props.item);

        if (this.props.item.children?.length > 0 && !this.props.item.path)
            this.toggleMenu(!this.state.open);
    }

    async toggleMenu(state: boolean) {
        // Only toggle if item has children
        if (this.props.item.children?.length > 0) {
            this.setState({ init: false });
            if (state) this.props.addExpandedMenuItem(this.props.item.id);
            else this.props.remExpandedMenuItem(this.props.item.id);
        }
    }

    async childClick() {
        await this.toggleMenu(!this.state.open);
    }

    render() {
        let classNames = "button";

        switch (this.props.item.iconType) {
            case MenuItemIconType.Info:
                classNames += " infoStage_Colour";
                break;
            case MenuItemIconType.Processing:
                classNames += " processingStage_Colour";
                break;
            case MenuItemIconType.Reports:
                classNames += " reportingStage_Colour";
                break;
            case MenuItemIconType.Admin:
                classNames += " admin_Colour";
                break;
        }

        return (
            <li
                className={`menu-item${
                    !!this.props.item.children.length ? " has-children" : ""
                }${this.state.open ? " open" : ""}${
                    this.state.init ? " init" : ""
                }`}
                data-place="left"
                data-tip={this.props.collapsed ? this.props.item.name : ""}>
                <Link
                    ref={this.state.myRef}
                    className={`${classNames}${
                        this.props.item.icon === "home" ? " home" : ""
                    }${
                        this.props.selected === this.props.item
                            ? " current"
                            : ""
                    }`}
                    to={this.props.item.path || "#"}
                    onClick={this.clicked.bind(this)}>
                    <div className="icon">
                        {this.props.item.icon !== "home" && (
                            <span>{this.props.item.icon}</span>
                        )}
                    </div>
                    <span>{this.props.item.name}</span>
                </Link>
                {this.props.item.children &&
                    this.props.item.children.length > 0 && (
                        <>
                            <MainMenuCollection
                                items={this.props.item.children}
                                selected={this.props.selected}
                                collapsed={this.props.collapsed}
                                menuItemClicked={item =>
                                    this.props.menuItemClicked(item)
                                }
                            />

                            <span
                                className="child-indicator"
                                onClick={this.childClick.bind(this)}></span>
                        </>
                    )}
            </li>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { ui } = state.db;
    return {
        expanded: ui.expandedMenuItems,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addExpandedMenuItem: (id: string) => dispatch(addExpandedMenuItem(id)),
        remExpandedMenuItem: (id: string) => dispatch(remExpandedMenuItem(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenuItem);
